/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerAccountRegistrationRequestModel } from '../../models/practitioner-account-registration-request-model';

export interface PractitionerRegisterPractitionerPost$Params {
      body?: PractitionerAccountRegistrationRequestModel
}

export function practitionerRegisterPractitionerPost(http: HttpClient, rootUrl: string, params?: PractitionerRegisterPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, practitionerRegisterPractitionerPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<string>;
    })
  );
}

practitionerRegisterPractitionerPost.PATH = '/Practitioner/RegisterPractitioner';
